module.exports = __webpack_public_path__ + "img/1.ff0c37c9.jpg";